import { chatAxios, CHAT_AUTH_URL, DISABLE_BACKEND_CHATBOT_CALLS } from './chatConfig';

let chatAuthInitialized = false;

export const ChatAuthService = {
  async autoLogin(): Promise<boolean> {
    if (chatAuthInitialized) {
      return true;
    }
    // Chamadas ao backend-chatbot desativadas por enquanto (não chama o login)
    if (DISABLE_BACKEND_CHATBOT_CALLS) {
      return false;
    }

    try {
      const username = process.env.REACT_APP_CHAT_USERNAME || 'admin';
      const password = process.env.REACT_APP_CHAT_PASSWORD || 'admin123';

      const response = await chatAxios.post(
        `${CHAT_AUTH_URL}/login`,
        { username, password },
        {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (response.status === 200 || response.status === 201) {
        chatAuthInitialized = true;
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  },

  isAuthenticated(): boolean {
    return chatAuthInitialized;
  },

  clearAuth(): void {
    chatAuthInitialized = false;
  },
};
